import { FunctionComponent, useState } from 'react';
import {
    Drawer,
    Link,
    Stack,
    SvgIcon,
    Typography,
    useTheme,
} from '@mui/material';
import { CardCode } from '@/models/cardcodes';
import ArrowLeftIcon from '@heroicons/react/24/solid/ArrowLeftIcon';
import { ActiveCodesCard } from '@/pageContents/specialTarifs/ActiveCodesCard';
import { AddCodes } from '@/pageContents/specialTarifs/AddCodes';

export const SpecialTarifsDetailsContent: FunctionComponent<{
    cardCode: CardCode;
}> = ({ cardCode }) => {
    const theme = useTheme();

    const [isOpen, setIsOpen] = useState(false);
    const toggleAddCodesDrawer = () => {
        setIsOpen(!isOpen);
    };

    return (
        <Stack spacing={theme.page.verticalSpacing}>
            <Link
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    color: 'text.primary',
                    mb: 6,
                }}
                href='/spezialtarife'
            >
                <SvgIcon
                    fontSize='small'
                    sx={{
                        mr: 2,
                    }}
                >
                    <ArrowLeftIcon />
                </SvgIcon>

                <Typography variant='subtitle2' component='span'>
                    Spezial Tarife
                </Typography>
            </Link>
            <Typography variant='h5'>
                Spezial Tarif: {cardCode.externalCode}
            </Typography>
            <Typography
                sx={{
                    mb: 3,
                }}
            >
                Geben Sie diese Codes an Ihre Gäste weiter. <br />
                Jeder Code berechtigt zur einmaligen Buchung eines
                Promotion-Tickets.
            </Typography>
            <Drawer anchor='right' open={isOpen} onClose={toggleAddCodesDrawer}>
                <AddCodes onClose={toggleAddCodesDrawer} cardCode={cardCode} />
            </Drawer>
            <ActiveCodesCard
                onAddButtonClick={toggleAddCodesDrawer}
                cardCode={cardCode}
            />
        </Stack>
    );
};
